import { FaBoxOpen, FaDatabase, FaFileInvoiceDollar, FaGear, FaHexagonNodes, FaHouse, FaLifeRing, FaMoneyBillWave, FaUserGear, FaWifi } from "react-icons/fa6";

export const NavLinkItemReseller = [
  { id: 1, name: "Dashboard", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  { id: 2, name: "Hotspot", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  { id: 2, name: "Data Vocer", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  { id: 2, name: "Hotspot Aktif", icon: FaHouse, path: "/dashboard-menu", type: "link" },
  { id: 12, name: "Pengaturan", icon: FaGear, path: "/dashboard/setting", type: "link" },
];